import useWebSocket from "react-use-websocket";
import { v4 as uuidv4 } from "uuid";
import { useEffect } from "react";
import { useState } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import DateTimeCell from "./DateTimeCell";
import FileName from "./FileName";
import URLCell from "./URLCell";
import { alpha, styled } from "@mui/material/styles";
import { useSpeechSynthesis } from "react-speech-kit";
const ODD_OPACITY = 0.1;

const PatentsTable = () => {
  const [clientID, setClientID] = useState("");
  const [chyronData, setChyronData] = useState([]);
  const { lastJsonMessage } = useWebSocket(
    `wss://${process.env.REACT_APP_DOMAIN}/ws/patent/?client=${clientID}`,
    {
      onOpen: () => setChyronData([]),
      shouldReconnect: () => true,
    }
  );
  const { speak } = useSpeechSynthesis();

  useEffect(() => {
    setClientID(uuidv4());
  }, []);

  useEffect(() => {
    if (lastJsonMessage !== null) {
      if (lastJsonMessage.length === undefined) {
        setChyronData((prev) => [lastJsonMessage].concat(prev));
        console.log(lastJsonMessage);
        if (lastJsonMessage["filename"].includes("clinical")) {
          speak({ text: "A new clinical trial file is posted" });
        } else if (lastJsonMessage["filename"].includes("patent")) {
          speak({ text: "A new patent file is posted" });
        } else {
          speak({ text: "A new trade mark file is posted" });
        }
      } else {
        setChyronData((prev) => lastJsonMessage.concat(prev));
      }
    }
  }, [lastJsonMessage, setChyronData]);

  const getRows = () => {
    return chyronData.map((item, index) => ({
      id: index,
      col1: item["time"],
      col2: item["filename"],
      col3: item["filepath"],
    }));
  };

  const columns = [
    { field: "col1", headerName: "Time", flex: 1, renderCell: DateTimeCell },
    { field: "col2", headerName: "File Name", flex: 3, renderCell: FileName },
    { field: "col3", headerName: "Download", flex: 1, renderCell: URLCell },
  ];

  const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: theme.palette.grey[300],
      "&:hover, &.Mui-hovered": {
        backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
      "&.Mui-selected": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY + theme.palette.action.selectedOpacity
        ),
        "&:hover, &.Mui-hovered": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
          ),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: alpha(
              theme.palette.primary.main,
              ODD_OPACITY + theme.palette.action.selectedOpacity
            ),
          },
        },
      },
    },
  }));

  return (
    <StripedDataGrid
      rows={getRows()}
      columns={columns}
      getRowHeight={() => "auto"}
      getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd")}
    />
  );
};

export default PatentsTable;
